import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';

import HeaderPage from './HeaderPage';
import DraftTitleAndBlurbContainer from '../containers/DraftTitleAndBlurbContainer';
import CreateDraftCard from '../components/CreateDraftCard';

import Footer from '../components/Footer';
import { Agent } from 'https';
import { ArgumentOutOfRangeError } from 'rxjs';

const styles = {
  promptCardWrapper: {
    margin: '0 auto',
    width: '37.5rem',
  },
};

class DraftTitleAndBlurbPage extends Component {
  componentDidMount() {
    if (this.props.container) {
      this.props.container.setup();
    }
  }

  componentWillUnmount() {
    this.props.container.destroy();
  }

  validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }

  validImage(item) { 

    if(this.validURL(item.url) || this.validURL(item)){
      return true
    }
    return false
  }

  render() {
    const { classes, container } = this.props;
    //console.log(container.state.image)
    //console.log(this.validURL(container.state.image.url))

    if (!(container.state.template)) {
      return null;
    }
    return (
      <div>
        <HeaderPage titleHeader={`Write ${container.state.template.name} Jam Title and Blurb`} descriptionHeader="Give a title and description of the jam." showBtns={false} />
        <div className={classes.promptCardWrapper}>
          <CreateDraftCard
            type={container.state.template.name}
            container={container}
            description="Short description to tease the Jam."
          />
        </div>
        {
          (container.state.blurb && this.validImage(container.state.image) && container.state.title) ? <Footer actionBtnLabel="Crew Jam" backBtnLabel="Back to Prompt" draftTo="/card/detail/new?isSeeded=true" draft="Store as Seeded Jam" to="/crew/new" back={`/create/${this.props.match.params.slug}/select/addPrompt`} /> : ''
        }
      </div>
    );
  }
}


function DraftTitleAndBlurbPageWrapper(props) {
  const { classes } = props;

  return (
    <Subscribe to={[DraftTitleAndBlurbContainer]}>
      { container => (
        <div>
          {container && (
          <DraftTitleAndBlurbPage {...props} classes={classes} container={container} />
          )}
        </div>
      )}
    </Subscribe>
  );
}

export default injectSheet(styles)(DraftTitleAndBlurbPageWrapper);



// WEBPACK FOOTER //
// ./src/pages/DraftTitleAndBlurbPage.js